// `video.lipsync`: live's Lip-Sync tool (#216).
// Live's label map lacks LIP_SYNC too, so its list shows no word for one; the tool's own form
// builds the body.
import { VideoLipsyncQuote, VideoLipsyncRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.lipsync"> = {
  type: "video.lipsync",
  label: "",
  source: "form",
  pair: "video.lipsync",
  fields: () => ({}),
  request: VideoLipsyncRequest,
  quote: VideoLipsyncQuote,
};
